<script lang="ts">
  import { observe } from "$lib/actions/observe";

  let {
    sectionLabel = "",
    headline = "",
    intro = "",
    blocks = [] as Array<{
      label?: string;
      lines?: string[];
    }>
  } = $props();
</script>

<section>
  <div class="container">
    <div class="legal fade-up" use:observe>
      {#if sectionLabel}
        <span class="section-label">{sectionLabel}</span>
      {/if}
      {#if headline}
        <h1>{headline}</h1>
      {/if}
      {#if intro}
        <p class="copy">{intro}</p>
      {/if}

      {#each blocks as block}
        <div class="legal-block">
          {#if block.label}
            <h2>{block.label}</h2>
          {/if}
          {#if block.lines}
            <address>
              {#each block.lines as line, i}
                {#if i > 0}<br />{/if}{line}
              {/each}
            </address>
          {/if}
        </div>
      {/each}
    </div>
  </div>
</section>

<style>
  .legal {
    max-width: 60ch;
    margin-inline: auto;
    padding-block: var(--space-2xl, 4rem);
  }

  .legal-block {
    margin-top: var(--space-lg, 2rem);
  }

  .legal-block h2 {
    font-size: 1.1rem;
    margin-bottom: var(--space-xs, 0.5rem);
  }

  address {
    font-style: normal;
    line-height: 1.7;
    color: var(--muted);
  }
</style>
